import get from 'lodash/get';

const employeeRoleCheck = state => {
  return get(state, 'dashboard.featureFlag.enable_location_permission', false);
};

export default employeeRoleCheck;
